import React from 'react'

import ChatRoom from '../addons/chat/ChatRoom'

class ChatIframePage extends React.Component {
  render() {
    const { appId, roomId, mode, token } = this.props.match.params
    return <ChatRoom appId={appId} roomId={roomId} mode={mode} token={token} />
  }
}

export default ChatIframePage



// WEBPACK FOOTER //
// ./src/containers/ChatIframePage.js